export const GET_LISTE_BIANCHE_DATA = "GET_LISTE_BIANCHE_DATA";
export const EXPORT_LISTE_BIANCHE_LOADING = "EXPORT_LISTE_BIANCHE_LOADING";
export const CREATE_LISTE_BIANCHE_DATA = "CREATE_LISTE_BIANCHE_DATA";
export const GET_LISTE_BIANCHE = "GET_LISTE_BIANCHE";
export const CREATE_UPDATE_DELETE_LISTE_BIANCHE =
  "CREATE_UPDATE_DELETE_LISTE_BIANCHE";
